import * as R from 'ramda'

import { statusSelectOptions } from 'utils/translate'
import { POSITION_FIELD, STATUS_FIELD } from './model'

export const mapInternalStateToPayload = state => {
  const { position, status } = state ?? {}

  return {
    project: R.prop('value', position),
    status: R.prop('value', status),
  }
}

export const mapPositionToInternalState = state => {
  const { id, name, status, hasInterviewModule } = state ?? {}

  return {
    [POSITION_FIELD]: { label: name, value: id },
    [STATUS_FIELD]: R.find(
      ({ value }) => R.equals(value, status),
      statusSelectOptions({ hasInterviewModule }),
    ),
  }
}
